/* Round twenty-one (2026-08-30), delivery: the hero slider's inline script
   (sections/cl-hero.liquid) as a cacheable asset, loaded with defer. One
   init per [data-cl-hero] root, re-run on shopify:section:load; the body is
   the round-twenty script with one addition, noted inline: the first
   placement of the track does not animate. */
(function () {
  var FILL = 'cl-hero-dot-fill';

  function init(root) {
    if (!root || root.dataset.clHeroReady === '1') return;
    root.dataset.clHeroReady = '1';

    var track    = root.querySelector('[data-cl-hero-track]');
    var viewport = root.querySelector('[data-cl-hero-viewport]');
    var slides   = Array.prototype.slice.call(root.querySelectorAll('[data-cl-hero-slide]'));
    var dots     = Array.prototype.slice.call(root.querySelectorAll('[data-cl-hero-dot]'));
    var fills    = Array.prototype.slice.call(root.querySelectorAll('[data-cl-hero-fill]'));
    var prev     = root.querySelector('[data-cl-hero-prev]');
    var next     = root.querySelector('[data-cl-hero-next]');
    if (!track || !viewport || slides.length < 2) return;

    var index = 0, dragging = false, paused = {};
    var reduced  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.autoplay === 'true' && !reduced && fills.length === slides.length;
    if (!autoplay) root.classList.add('is-static');

    // A true loop: a copy of the last slide sits before the first and a copy
    // of the first after the last, so moving past either end slides onto a
    // copy, and once that transition has ended the track jumps, without a
    // transition, to the real slide in the same picture. `pos` is the track
    // position (0 = the leading copy, 1..n = the real slides, n + 1 = the
    // trailing copy); `index` stays the real slide for dots and aria. Under
    // reduced motion the slides cross-fade in place and the copies are hidden.
    var n = slides.length, pos = 1;
    function clone(src) {
      var c = src.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('inert', '');
      c.removeAttribute('data-cl-hero-slide');
      c.setAttribute('data-cl-hero-clone', '');
      c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      c.querySelectorAll('img[loading="eager"]').forEach(function (img) { img.setAttribute('loading', 'lazy'); img.removeAttribute('fetchpriority'); });
      return c;
    }
    if (!reduced) {
      track.insertBefore(clone(slides[n - 1]), slides[0]);
      track.appendChild(clone(slides[0]));
    }

    function place() { track.style.transform = 'translateX(' + (-100 * pos) + '%)'; }
    function paint() {
      if (!reduced) place();
      slides.forEach(function (s, i) { s.setAttribute('aria-hidden', i === index ? 'false' : 'true'); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }
    // after a slide onto a copy, snap to its original with no transition
    function settle() {
      if (reduced || dragging) return;
      if (pos !== 0 && pos !== n + 1) return;
      pos = pos === 0 ? n : 1;
      track.style.transition = 'none';
      place();
      void track.offsetWidth;
      track.style.transition = '';
    }
    track.addEventListener('transitionend', function (e) {
      if (e.target === track && e.propertyName === 'transform') settle();
    });

    // The active dot's fill is a CSS animation whose duration is the autoplay
    // delay (--cl-hero-delay); its animationend is the only thing that advances
    // the slider. Restart = drop the class, flush styles, add it back.
    function charge() {
      if (!autoplay) return;
      fills.forEach(function (f, i) {
        f.classList.remove('is-charging');
        if (i === index) { void f.offsetWidth; f.classList.add('is-charging'); }
      });
    }
    function setPaused(reason, on) {
      paused[reason] = on;
      var any = false;
      for (var k in paused) if (paused[k]) any = true;
      root.classList.toggle('is-paused', any);
    }
    function go(to) {
      var target = ((to % n) + n) % n;
      var delta = to - index;                 // signed: +1 forward, -1 back, or a dot jump
      settle();                               // in case the previous snap is still pending
      if (Math.abs(delta) === 1) {
        // one step in the direction asked, through the copies at either end
        pos += delta;
      } else {
        pos = target + 1;                     // a dot jump: straight to the real slide
      }
      index = target;
      paint(); charge();
    }

    root.addEventListener('animationend', function (e) {
      if (e.animationName !== FILL || document.hidden || dragging) return;
      go(index + 1);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { go(parseInt(dot.dataset.clHeroDot, 10)); });
    });
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    // Hover does NOT pause the charge (client, 2026-08-25): the slider keeps
    // its rhythm under the pointer. Keyboard focus, a drag and a hidden tab
    // still do.
    root.addEventListener('focusin', function (e) {
      var kb = false;
      try { kb = !!(e.target && e.target.matches && e.target.matches(':focus-visible')); } catch (err) { kb = true; }
      if (kb) setPaused('focus', true);
    });
    root.addEventListener('focusout', function () { setPaused('focus', false); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
    });

    var startX = null, dx = 0, pointerId = null, captured = false, draggedAt = 0;
    function down(x) { settle(); startX = x; dx = 0; dragging = true; setPaused('drag', true); track.classList.add('is-dragging'); }
    function move(x) {
      if (startX === null) return;
      dx = x - startX;
      // Capture only once this is a drag: capturing on pointerdown redirected
      // the click to the viewport and the hero's buttons never fired.
      if (!captured && pointerId !== null && Math.abs(dx) > 6) {
        captured = true;
        try { viewport.setPointerCapture(pointerId); } catch (err) { /* gone */ }
      }
      if (!reduced) track.style.transform = 'translateX(calc(' + (-100 * pos) + '% + ' + dx + 'px))';
    }
    function up() {
      if (startX === null) return;
      track.classList.remove('is-dragging');
      var threshold = Math.min(120, viewport.offsetWidth * 0.15);
      dragging = false;
      if (Math.abs(dx) > 6) draggedAt = Date.now();
      if (dx < -threshold) go(index + 1);
      else if (dx > threshold) go(index - 1);
      else paint();
      startX = null; dx = 0; pointerId = null; captured = false;
      setPaused('drag', false);
    }
    // the click that ends a drag must not follow the link under the pointer
    viewport.addEventListener('click', function (e) {
      if (draggedAt && Date.now() - draggedAt < 400) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    viewport.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
    viewport.addEventListener('touchmove',  function (e) { move(e.touches[0].clientX); }, { passive: true });
    viewport.addEventListener('touchend', up);
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      pointerId = e.pointerId; captured = false;
      down(e.clientX);
    });
    viewport.addEventListener('pointermove', function (e) { if (e.pointerType !== 'touch') move(e.clientX); });
    viewport.addEventListener('pointerup', up);
    viewport.addEventListener('pointercancel', up);
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // A fill that completed in a hidden tab is ignored above; on return the
    // charge restarts from zero instead of sitting full without advancing.
    document.addEventListener('visibilitychange', function () {
      if (!root.isConnected) return;
      if (document.hidden) { setPaused('hidden', true); return; }
      setPaused('hidden', false);
      charge();
    });

    // Round twenty-one: the script is deferred, so the track has already
    // been painted at 0 by the time init runs. The first placement (onto the
    // real first slide, past the leading copy) must not animate, or the
    // hero would slide in from the last slide's copy on every load.
    track.style.transition = 'none';
    paint();
    void track.offsetWidth;
    track.style.transition = '';
    charge();
  }
  /* How far down the page the hero starts, at rest: the header's height, plus
     anything else above it (the campaign top line). A viewport-tall hero gives
     exactly that back, so its foot lands on the fold.

     This used to read --cl-nav-h, but that is the nav bar's bottom edge as it
     is NOW, and it shrinks by the utility strip (and the top line) while the
     page scrolls away from the top: the hero grew by that much under the
     visitor's finger, and the picture re-scaled with it (cover). The hero's
     own document position does not move when the page scrolls, and it follows
     the header wherever the header changes: a resize, the fonts arriving, the
     top line appearing. cl-hero.css falls back to --cl-nav-h until this has
     run. Runs for every hero, including a one-slide one, which init() skips. */
  function measureOffset(root) {
    function set() {
      var top = Math.round(root.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0));
      if (String(top) !== root.dataset.clHeroTop) {
        root.dataset.clHeroTop = String(top);
        root.style.setProperty('--cl-hero-offset', top + 'px');
      }
    }
    if (root.dataset.clHeroOffsetReady === '1') { set(); return; }
    root.dataset.clHeroOffsetReady = '1';
    set();
    window.addEventListener('resize', set);
    window.addEventListener('load', set);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
    /* the header can change height without a resize (the top line loads its
       clock, the utility strip wraps); watch the block above the hero */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(set);
      var el = root.closest('.shopify-section') || root;
      var prev = el.previousElementSibling;
      while (prev) { ro.observe(prev); prev = prev.previousElementSibling; }
    }
  }
  function scan(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-cl-hero]')) { measureOffset(scope); init(scope); }
    if (scope.querySelectorAll) Array.prototype.forEach.call(scope.querySelectorAll('[data-cl-hero]'), function (r) { measureOffset(r); init(r); });
  }
  /* The tag is emitted once per instance and the theme editor re-inserts it
     with a re-rendered section, so a second run only scans for new roots. */
  if (window.clHeroScan) { window.clHeroScan(document); return; }
  window.clHeroScan = scan;
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
